import { CONTACT } from './contact.js';

/**
 * Shared details for the /privacy and /terms pages.
 *
 * Update `lastUpdated` any time the wording on either page changes — the date
 * is printed at the top of both documents.
 *
 * `email` and `mailingAddress` are optional: fill either one in and it shows up
 * automatically in the "Contact us" block at the bottom of both pages. Leave
 * them empty and the block falls back to phone + Facebook.
 */
export const LEGAL = {
  business: CONTACT.business,
  lastUpdated: 'August 29, 2026',
  email: '',
  mailingAddress: '',
  governingState: 'New York',
};
